import { flow, getParent } from 'mobx-state-tree';
import { getIdentifier } from '~/mst/utils';
import omit from 'lodash/omit';
import type { IUserCalibrationModel } from './model';
import type { IDevice } from '../../..';

export default (self: IUserCalibrationModel) => ({
  destroy: flow(function* destroy() {
    self.startSyncing();
    try {
      const device = getParent<IDevice>(self, 3);
      const payload = device.toJSON();
      yield device.update({
        ...payload,
        user_calibration: omit(payload.user_calibration, getIdentifier(self) as string)
      });
      self.finishSyncing();
    } catch (error) {
      self.failSyncing(error);
    }
  })
});
